import {WorkrequestLndBaseDetails} from '../lnd-w-form/workrequest-lnd-base-details';

export class WorkrequestLndNwDetails extends WorkrequestLndBaseDetails {
  applicationFeeRequired: boolean;
  Commercialrequired: boolean;
  Residentialrequired: boolean;
  Industrialrequired: boolean;

  constructor() {
    super();
    this.applicationFeeRequired = false;
    this.Commercialrequired = false;
    this.Residentialrequired = false;
    this.Industrialrequired = false;
  }

  toUpperCase() {
  }

  setDescriptionOfWork() {
    this.descriptionOfWork = '';
    if (this.Commercialrequired) {
      this.descriptionOfWork += 'Type of Development: Commercial' + '\n\n';
    } else if (this.Residentialrequired) {
      this.descriptionOfWork += 'Type of Development: Residential' + '\n\n';
    } else if (this.Industrialrequired) {
      this.descriptionOfWork += 'Type of Development: Industrial' + '\n\n';
    }

    if (this.subdivisionRequiredYes) {
      this.descriptionOfWork += 'Proceeding to Subdivision: Yes' + '\n\n';
    } else if (this.subdivisionRequiredNo) {
      this.descriptionOfWork += 'Proceeding to Subdivision: No' + '\n\n';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/lnd-nw-form/workrequest-lnd-nw-details.ts